import axios from 'axios';
import { z } from 'zod';

export const CNC_QUOTING_API_URL = process.env.NEXT_PUBLIC_CNC_QUOTING_API_URL;

export const CNC_QUOTING_APP_URL = process.env.NEXT_PUBLIC_CNC_QUOTING_APP_URL;

const cncQuotingApi = axios.create({ baseURL: CNC_QUOTING_API_URL });

const cncHandoffDestinationSchema = z.enum(['quotes', 'drawings']);
export type CncHandoffDestination = z.infer<typeof cncHandoffDestinationSchema>;

const cncHandoffResponseSchema = z.object({
  handoff_id: z.string(),
  destination: cncHandoffDestinationSchema,
  tab: z.enum(['single', 'batch']).nullable(),
});
export type CncHandoffResponse = z.infer<typeof cncHandoffResponseSchema>;

export async function postCncHandoff(
  file: File | Blob
): Promise<CncHandoffResponse> {
  const form = new FormData();
  form.append('file', file, file instanceof File ? file.name : 'upload');

  const { data } = await cncQuotingApi.post('/api/v1/handoff', form);
  return cncHandoffResponseSchema.parse(data);
}

export function cncHandoffRedirectUrl(handoff: CncHandoffResponse): string {
  return `${CNC_QUOTING_APP_URL}/${handoff.destination}?handoff=${handoff.handoff_id}`;
}
